<template>
  <div class="h-full flex flex-col overflow-y-hidden">
    <keep-alive>
      <component :is="currentComponent" class="flex-1"></component>
    </keep-alive>
    <BottomNav />
  </div>
</template>
<script>
import Home from "@/views/home/Home";
import Menu from "@/views/menu/Menu";
import Cart from "@/views/cart/Cart";
import Orders from "@/views/orders/Orders";
import More from "@/views/more/More";
import BottomNav from "@/views/bottomnav/BottomNav.vue";
export default {
  components: { Home, Menu, Cart, Orders, More, BottomNav },
  computed: {
    currentComponent() {
      return this.$store.state.currentComponent;
    },
  },
};
</script>
